import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { get, map } from 'lodash';
import { withRouter } from 'react-router-dom';
import ContentfulFields from 'components/ContentfulFields';
import { Tabs } from 'components/Ui';
import ContactUs from 'containers/Landing/ContactUs/Loadable';
import EquipmentManuals from 'containers/Landing/EquipmentManuals/Loadable';
import { isSsr } from 'utils/ssrHelper';
import { getToUrl } from 'utils/translation';
import styles from './styles.scss';

const Support = ({
  match,
  history,
  site: {
    components: { page },
  },
}) => {
  const SUPPORT_TABS = [
    {
      path: getToUrl('/support/contact-us', 'U55'),
      name: 'Contact us',
      component: <ContactUs />,
    },
    {
      path: getToUrl('/support/equipment-manuals', 'U56'),
      name: 'Dispensers and Accessories Manuals',
      component: <EquipmentManuals />,
    },
  ];

  const TAB_TITLES = map(SUPPORT_TABS, (tab) => tab.name);
  const TAB_CONTENT = map(SUPPORT_TABS, (tab) => tab.component);

  const getCurrentTab = () =>
    SUPPORT_TABS.find((tab) => tab.path === match.url);

  const handleTabChange = (value) => {
    history.push(SUPPORT_TABS[value].path);
  };

  const activeTab = SUPPORT_TABS.indexOf(getCurrentTab());

  const urlQueryStr = !isSsr() ? window.location.search : '';
  const params = new URLSearchParams(urlQueryStr);
  const submittedParam = params.get('p');
  const submitted = submittedParam === 'success';

  return (
    <Fragment>
      {!submitted &&
        TAB_TITLES === 'Contact us' &&
        page &&
        page.contentModules.map((banner) => (
          <ContentfulFields
            type={get(banner, 'sys.contentType.sys.id')}
            document={banner}
            key={banner.sys.id}
          />
        ))}
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        className={styles.content}
        tabLabels={TAB_TITLES}
        content={TAB_CONTENT}
        variant="fullWidth"
        modernTabStyling
      />
    </Fragment>
  );
};

Support.propTypes = {
  site: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(Support);
